const NavigationRouteType = {
  ADMIN: 'ADMIN',
  COACH: 'COACH',
};

export {
  NavigationRouteType,
};
